export default __webpack_public_path__ + "static/media/Mammuthus Shield.b3d23d69.jpg";